import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { CostCenterRequest } from 'src/app/models/requests/new-costcenter-request';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-costcenter',
  templateUrl: './new-costcenter.component.html',
  styleUrls: ['./new-costcenter.component.css']
})
export class NewCostCenterComponent {

  name: string = '';
  description: string = '';
  code:string = '';


  constructor(private costcenterService: CostCentersService, private notification: NotificationService) { }

  
  onSubmit(): void {
    let CostCenterVm: CostCenterRequest = {
      name: this.name,
      description: this.description,
      code: this.code
    };

    this.costcenterService.saveCostCenter(CostCenterVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`CostCenter Created successfully ${data}`);
          this.description = this.name = this.code = '';

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
